import * as React from 'react';
import { useSelector } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { NavigationBox } from './navigationStyled';
import { useNavigate } from 'react-router-dom';
import { LocalStorageKeys, PageName } from "../../QuoteRequest/Content";
import { useEffect } from 'react';
import { UserRole } from "../../QuoteRequest/Content";
import { isJsonString } from "../../../Helper/Helper";
const menu = ['Home', 'Manage Bundles', 'Create Request'];
const pricingTeamMenu = ['Home', 'Manage Bundles', 'Create Request', 'Manage Users', 'Manage Data', 'Manage Sync'];

const Navigation = () => {
    let loggedUser = useSelector((state) => state?.UserReducer?.loggedUser);
    if (!loggedUser?.user) {
        loggedUser = isJsonString(
            sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER)
        )
            ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER))
            : null

    }
    const [anchorElNav, setAnchorElNav] = React.useState('');
    const [activeMenuItem, setActiveMenuItem] = React.useState('');
    const [menuItems, setMenuItems] = React.useState(menu);
    const navigate = useNavigate();

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    useEffect(() => {

        if (loggedUser?.userRole) {
            if (loggedUser?.userRole[0]?.id === UserRole.PRICINGTEAM || 
                loggedUser?.userRole[0]?.id === UserRole.PRICINGMANAGER || 
                loggedUser?.userRole[0]?.id === UserRole.PRICINGVP) {
                setMenuItems(pricingTeamMenu);
            }
            else {
                setMenuItems(menu);
            }
        }
    }, [loggedUser]);
    const handleCloseNavMenu = () => {
        setAnchorElNav('');
    };
    React.useEffect(() => {

        if (sessionStorage.getItem(LocalStorageKeys.CURRENTPAGE) === PageName.ERRORPAGE) {
            setMenuItems([]);

        }

        setActiveMenuItem(sessionStorage.getItem(LocalStorageKeys.CURRENTPAGE));
        if (sessionStorage.getItem(LocalStorageKeys.CURRENTPAGE) != PageName.MANAGEDATAPAGE) {
            sessionStorage.removeItem(LocalStorageKeys.MANAGEDATATAB);
        }

    })
    const handleMenuItemClick = (page) => {

        if (sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL)) {
            setActiveMenuItem(page);
            handleCloseNavMenu();
            switch (page) {
                case 'Home': sessionStorage.setItem(LocalStorageKeys.CURRENTPAGE, PageName.HOMEPAGE);
                    navigate('/');
                    break;
                case 'Create Request': sessionStorage.setItem(LocalStorageKeys.CURRENTPAGE, PageName.QUOTEPAGE);
                    navigate(
                        '/quoterequest',
                        {
                            state: {
                                oppurtunityId: sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID),
                                requestType: 'Create'
                            }
                        });
                    break;
                case 'Manage Users': sessionStorage.setItem(LocalStorageKeys.CURRENTPAGE, PageName.MANAGEUSERPAGE);
                    navigate(
                        '/manageusers');
                    break;
                case 'Manage Data': sessionStorage.setItem(LocalStorageKeys.CURRENTPAGE, PageName.MANAGEDATAPAGE);
                    navigate(
                        '/managedata');
                    break;
                case 'Manage Sync': sessionStorage.setItem(LocalStorageKeys.CURRENTPAGE, PageName.MANAGESYNCPAGE);
                    navigate(
                        '/managesync');
                    break;
                case 'Manage Bundles': sessionStorage.setItem(LocalStorageKeys.CURRENTPAGE, PageName.MANAGEBUNDLESPAGE);
                    navigate(
                        '/managebundles');
                    break;
                default:
                    break;

            }
        }
    };

    return (
        // TO DO
        <>
            <NavigationBox sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }} >
                <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleOpenNavMenu}
                    color="inherit"
                >

                    <MenuIcon className="hamburger" />
                </IconButton>
                <Menu
                    id="menu-appbar"
                    anchorEl={anchorElNav}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    open={Boolean(anchorElNav)}
                    onClose={handleCloseNavMenu}
                    sx={{
                        display: { xs: 'block', md: 'none' },
                    }}
                >
                    {menuItems.map((page) => (
                        <MenuItem
                            key={page}
                            onClick={() => handleMenuItemClick(page)}
                            className={activeMenuItem === page ? 'active' : ''}
                        >
                            <Typography textAlign="center">{page}</Typography>
                        </MenuItem>
                    ))}
                </Menu>
            </NavigationBox>
            <NavigationBox className="menuWeb" sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                {menuItems.map((page) => (
                    <Button
                        key={page}
                        onClick={() => handleMenuItemClick(page)}
                        sx={{
                            my: 2,
                            color: 'white',
                            display: 'block',
                            fontFamily: '"Noto Sans", sans-serif',
                            fontWeight: activeMenuItem === page ? 600 : 'normal',
                        }}
                        className={activeMenuItem === page ? 'active' : ''}
                    >
                        {page}
                    </Button>
                ))}
            </NavigationBox>
        </>
    )
}

export default Navigation;
